"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "ContextUpgradeable__factory", {
  enumerable: true,
  get: function get() {
    return _ContextUpgradeable__factory.ContextUpgradeable__factory;
  }
});
Object.defineProperty(exports, "PausableUpgradeable__factory", {
  enumerable: true,
  get: function get() {
    return _PausableUpgradeable__factory.PausableUpgradeable__factory;
  }
});
exports.introspection = void 0;
var _introspection = _interopRequireWildcard(require("./introspection"));
exports.introspection = _introspection;
var _ContextUpgradeable__factory = require("./ContextUpgradeable__factory");
var _PausableUpgradeable__factory = require("./PausableUpgradeable__factory");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }